module.exports = __webpack_public_path__ + "static/img/gjewm.0ea2c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gjewm.jpg
// module id = aNUA
// module chunks = 1